import { Link } from "react-router-dom";

import { FaCheck } from "react-icons/fa6";

import Button from "@/components/Button";
import Input from "@/components/Input";

export default function OTPPage() {
  return (
    <div className="flex flex-col items-center h-full gap-6 px-6 pt-[20vh]">
      <div className="self-start flex flex-col gap-2">
        <h1 className="text-[28px] font-semibold">Enter OTP</h1>
        <h2 className="text-[#595959] text-[12px]">
          A 4 digit code has been sent to `phone-number`
        </h2>
      </div>
      <div className="w-full flex flex-col gap-2">
        <div className="relative w-full">
          <Input name="otp" placeholder="- - - -" type="number" title="OTP" />
          <FaCheck
            color="#f05a22"
            className="absolute top-[15px] right-4"
            size={20}
          />
        </div>
        <p className="pr-2 text-[#676666] self-end font-semibold text-[12px]">
          Didn't recieve code? <span className="text-[#F55D66]">Resend</span>
        </p>
      </div>
      <Link to="/auth/onboarding" className="w-full">
        <Button title="Verify OTP" />
      </Link>
    </div>
  );
}
